import { render } from "./Topstar.vue?vue&type=template&id=d40ba8ee&scoped=true"
import script from "./Topstar.vue?vue&type=script&lang=js"
export * from "./Topstar.vue?vue&type=script&lang=js"

import "./Topstar.vue?vue&type=style&index=0&id=d40ba8ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d40ba8ee"]])

export default __exports__